import { useTranslation } from "react-i18next";
import type { Tag } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import TagForm from "./TagForm";

function SidebarTagForm({ ...props }: any) {
  return <CrudEdit collectionName="tags" Form={TagForm} {...props} />;
}

function Tags() {
  const { t } = useTranslation();

  const columns: TableColumn<Tag>[] = useMemo(
    () => [
      {
        field: "name",
        header: t("tags.name"),
        sortable: true,
        renderType: "bold",
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("tags.name"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="tags"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarTagForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default Tags;
